// export const web_url = process.env.REACT_APP_TESTING_BACKEND;
// export const socket_url = process.env.REACT_APP_TESTING_BACKEND_WEBSOCKET;


export const web_url = process.env.REACT_APP_PRODUCTION_BACKEND;
export const socket_url = process.env.REACT_APP_PRODUCTION_BACKEND_WEBSOCKET;

export const researcherMailConst = process.env.REACT_APP_ADMIN_EMAIL;

export const MAX_FILE_SIZE = 5 * 1024 * 1024;

export const MAX_FILE_SIZE_OCR = 5 * 1024 * 1024;

export const WORD_LIMIT = 500;

export const apiKey_g = process.env.REACT_APP_GOOGLE_VISION_API_KEY;

export const videoUrlTamil = process.env.REACT_APP_AZURE_VIDEO_URL_TAMIL;
export const videoUrlSinhala = process.env.REACT_APP_AZURE_VIDEO_URL_SINHALA;
